<template>
  <div class="personal-apply-page">
    <div class="top-nav">
      <button class="back-btn" type="button" aria-label="返回" @click="$router.go(-1)">
        <i class="el-icon-arrow-left"></i>
      </button>
      <h1 class="title">个人信息填写</h1>
    </div>

    <div class="intro-card">
      <div class="intro-icon"><i class="el-icon-user"></i></div>
      <div>
        <div class="intro-title">个人用户申请</div>
        <!-- <div class="intro-text">个人会员免费，审核通过后可参与联盟活动，暂不开放项目供需功能。</div> -->
      </div>
    </div>

    <div class="form-section">
      <div class="section-title">个人基本信息</div>
      <el-form
        ref="personalForm"
        class="personal-form"
        :model="formData"
        :rules="rules"
        label-position="top"
        hide-required-asterisk
        @submit.native.prevent
      >
        <el-form-item label="姓名" prop="realName" required>
          <el-input v-model.trim="formData.realName" maxlength="50" show-word-limit placeholder="请输入真实姓名" />
        </el-form-item>

        <el-form-item label="类型" prop="personalCategory" required>
          <el-radio-group v-model="formData.personalCategory" class="option-group">
            <el-radio-button v-for="item in categoryList" :key="item" :label="item">{{ item }}</el-radio-button>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="性别" prop="gender" required>
          <el-radio-group v-model="formData.gender" class="option-group">
            <el-radio-button v-for="item in genderList" :key="item" :label="item">{{ item }}</el-radio-button>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="年龄" prop="age" required>
          <el-input-number v-model="formData.age" :min="1" :max="120" :step="1" controls-position="right" />
        </el-form-item>

        <el-form-item label="联系方式" prop="contact" required>
          <el-input
            v-model.trim="formData.contact"
            maxlength="30"
            inputmode="tel"
            placeholder="请输入手机号或座机号码"
          />
        </el-form-item>

        <el-form-item label="城市" required>
          <div class="city-row">
            <el-form-item prop="province">
              <el-select v-model="formData.province" placeholder="请选择省份" @change="handleProvinceChange">
                <el-option v-for="item in provinceList" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item prop="city">
              <el-select v-model="formData.city" placeholder="请选择城市" :disabled="!formData.province">
                <el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.name" />
              </el-select>
            </el-form-item>
          </div>
        </el-form-item>

        <el-form-item label="地址" prop="detailAddress" required>
          <el-input
            v-model.trim="formData.detailAddress"
            type="textarea"
            :rows="3"
            maxlength="255"
            show-word-limit
            placeholder="请填写至少具体到社区的详细地址"
          />
        </el-form-item>

        <el-form-item label="目前职业状态" prop="employmentStatus" required>
          <el-radio-group v-model="formData.employmentStatus" class="option-group">
            <el-radio-button v-for="item in employmentList" :key="item" :label="item">{{ item }}</el-radio-button>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="公司（选填）" prop="personalCompany">
          <el-input v-model.trim="formData.personalCompany" maxlength="200" show-word-limit placeholder="请输入公司名称" />
        </el-form-item>

        <el-form-item label="加入目标（选填）" prop="joinTarget">
          <el-input
            v-model.trim="formData.joinTarget"
            type="textarea"
            :rows="3"
            maxlength="255"
            show-word-limit
            placeholder="请输入加入联盟希望达成的目标"
          />
        </el-form-item>

        <el-form-item label="擅长项（选填）" prop="skillItems">
          <el-input
            v-model.trim="formData.skillItems"
            type="textarea"
            :rows="3"
            maxlength="255"
            show-word-limit
            placeholder="请输入您的专业能力或擅长方向"
          />
        </el-form-item>
      </el-form>
    </div>

    <div class="submit-wrap">
      <el-button type="primary" :loading="submitting" @click="submitForm">提交审核</el-button>
    </div>
  </div>
</template>

<script>
const CONTACT_REGEXP = /^(?=.*\d)[0-9+()\-\s]{6,30}$/

export default {
  name: 'PersonalApplyStep2',
  data() {
    const validateContact = (rule, value, callback) => {
      if (!value) return callback(new Error('请输入联系方式'))
      if (!CONTACT_REGEXP.test(value)) return callback(new Error('联系方式格式不正确'))
      callback()
    }
    const validateAddress = (rule, value, callback) => {
      const address = String(value || '').trim()
      if (!address) return callback(new Error('请输入详细地址'))
      if (address.length < 4) return callback(new Error('地址请至少填写到社区'))
      if (address.length > 255) return callback(new Error('地址不能超过255个字符'))
      callback()
    }
    const validateAge = (rule, value, callback) => {
      if (value === null || value === undefined || value === '') return callback(new Error('请输入年龄'))
      if (!Number.isInteger(Number(value)) || Number(value) < 1 || Number(value) > 120) {
        return callback(new Error('年龄应为1到120之间的整数'))
      }
      callback()
    }
    return {
      categoryList: ['专业', '非专业'],
      genderList: ['男', '女', '其它'],
      employmentList: ['在职', '离职', '退休'],
      provinceList: [],
      cityList: [],
      submitting: false,
      formData: {
        realName: '',
        personalCategory: '',
        gender: '',
        age: null,
        contact: '',
        province: '',
        city: '',
        detailAddress: '',
        employmentStatus: '',
        personalCompany: '',
        joinTarget: '',
        skillItems: ''
      },
      rules: {
        realName: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 1, max: 50, message: '姓名不能超过50个字符', trigger: 'blur' }
        ],
        personalCategory: [{ required: true, message: '请选择类型', trigger: 'change' }],
        gender: [{ required: true, message: '请选择性别', trigger: 'change' }],
        age: [
          { validator: validateAge, trigger: 'change' }
        ],
        contact: [{ validator: validateContact, trigger: 'blur' }],
        province: [{ required: true, message: '请选择省份', trigger: 'change' }],
        city: [{ required: true, message: '请选择城市', trigger: 'change' }],
        detailAddress: [{ validator: validateAddress, trigger: 'blur' }],
        employmentStatus: [{ required: true, message: '请选择职业状态', trigger: 'change' }],
        personalCompany: [{ max: 200, message: '公司名称不能超过200个字符', trigger: 'blur' }],
        joinTarget: [{ max: 255, message: '加入目标不能超过255个字符', trigger: 'blur' }],
        skillItems: [{ max: 255, message: '擅长项不能超过255个字符', trigger: 'blur' }]
      }
    }
  },
  mounted() {
    const saved = this.$store.state.step1Data.formData || {}
    this.formData = Object.assign({}, this.formData, saved)
    this.getRegions('').then(list => {
      this.provinceList = list
      if (this.formData.province) {
        this.getRegions(this.formData.province).then(cityList => {
          this.cityList = cityList
        })
      }
    })
  },
  methods: {
    getRegions(parentId) {
      return this.$ajax.get('/api/region/get', { params: { parentId } }).then(res => {
        if (res.data.code !== 200) return []
        return res.data.data || []
      })
    },
    handleProvinceChange(provinceId) {
      this.formData.city = ''
      this.cityList = []
      if (!provinceId) return
      this.getRegions(provinceId).then(list => {
        this.cityList = list
      })
    },
    submitForm() {
      if (this.submitting) return
      this.$refs.personalForm.validate(valid => {
        if (!valid) return
        this.submitting = true
        const payload = {
          realName: this.formData.realName.trim(),
          personalCategory: this.formData.personalCategory,
          gender: this.formData.gender,
          age: Number(this.formData.age),
          contact: this.formData.contact.trim(),
          city: this.formData.city,
          detailAddress: this.formData.detailAddress.trim(),
          employmentStatus: this.formData.employmentStatus,
          personalCompany: this.formData.personalCompany.trim(),
          joinTarget: this.formData.joinTarget.trim(),
          skillItems: this.formData.skillItems.trim()
        }
        this.$store.commit('SET_STEP1_DATA', { formData: this.formData })
        this.$ajax.post('/api/user/personal/join', payload).then(res => {
          if (res.data.code === 200) {
            const userInfo = Object.assign({}, JSON.parse(sessionStorage.getItem('userInfo') || '{}'), res.data.data)
            sessionStorage.setItem('userInfo', JSON.stringify(userInfo))
            this.$store.commit('CLEAR_STEP1')
            this.$message.success('申请已提交，请等待审核')
            this.$router.replace('/apply/wait')
          }
        }).finally(() => {
          this.submitting = false
        })
      })
    }
  }
}
</script>

<style scoped>
.personal-apply-page {
  min-height: 100vh;
  padding-bottom: calc(180px + env(safe-area-inset-bottom));
  background: #f8fafc;
}
.top-nav {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 56px;
  background: #fff;
  border-bottom: 1px solid #f0f2f5;
}
.back-btn {
  position: absolute;
  left: 12px;
  width: 36px;
  height: 36px;
  border: 0;
  background: transparent;
  color: #333;
  font-size: 20px;
}
.title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
}
.intro-card {
  display: flex;
  gap: 12px;
  margin: 16px 16px 0;
  padding: 16px;
  border: 1px solid #d9e6ff;
  border-radius: 12px;
  background: #f2f7ff;
}
.intro-icon {
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #165dff;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}
.intro-title {
  margin-bottom: 5px;
  color: #1d4ed8;
  font-size: 14px;
  font-weight: 600;
}
.intro-text {
  color: #5c6b82;
  font-size: 12px;
  line-height: 1.6;
}
.form-section {
  margin: 16px;
}
.section-title {
  margin-bottom: 12px;
  padding-left: 9px;
  border-left: 4px solid #165dff;
  color: #1a1a1a;
  font-size: 16px;
  font-weight: 600;
}
.personal-form {
  padding: 18px 16px 2px;
  border-radius: 14px;
  background: #fff;
  box-shadow: 0 2px 10px rgba(31, 45, 61, 0.04);
}
.personal-form >>> .el-form-item__label {
  padding-bottom: 7px;
  color: #333;
  font-size: 13px;
  line-height: 20px;
}
.personal-form >>> .el-form-item.is-required .el-form-item__label:after {
  content: ' *';
  color: #f56c6c;
}
.personal-form >>> .el-input__inner,
.personal-form >>> .el-textarea__inner {
  border-color: #e5e7eb;
  border-radius: 9px;
  background: #f9fafb;
  font-size: 13px;
}
.personal-form >>> .el-input-number,
.personal-form >>> .el-input-number .el-input {
  width: 100%;
}
.option-group {
  display: flex;
  width: 100%;
}
.option-group >>> .el-radio-button {
  flex: 1;
}
.option-group >>> .el-radio-button__inner {
  width: 100%;
  padding: 12px 8px;
}
.city-row {
  display: flex;
  gap: 10px;
}
.city-row > .el-form-item {
  flex: 1;
  margin-bottom: 0;
}
.city-row >>> .el-select {
  width: 100%;
}
.submit-wrap {
  position: fixed;
  right: 0;
  bottom: calc(78px + env(safe-area-inset-bottom));
  left: 0;
  z-index: 20;
  padding: 10px 16px;
  background: rgba(255, 255, 255, 0.96);
  border-top: 1px solid #f0f2f5;
}
.submit-wrap >>> .el-button {
  width: 100%;
  height: 46px;
  border-radius: 10px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/menu/join/personal-second.vue